var ValidationForm = {
    '_hasConfirmationField': function (field, elements) {
        return (typeof(elements['Confirm_' + field]) != 'undefined');
    },

    'prepareFormFields': function (elements, formID) {
        var formFields = {};
        var auxField;

        for (field in elements) {
            if (elements[field] == null || typeof(elements[field].name) == 'undefined' || typeof(elements[field].name.split) == 'undefined') {
                continue;
            }

            auxField = elements[field].name.split('_');

            if (auxField.length > 1 && (auxField[0] != 'NoValidate' && auxField[0] != 'Confirm')) {
                auxField = auxField[1];
            } else {
                auxField = elements[field].name;
            }

            if (typeof(document.getElementById(formID).elements[auxField]) != 'undefined') {
                formFields[auxField] = elements[field];
            }
        }

        return formFields;
    },

    'validate': function (event) {
        var form = jQuery(event.target).closest('form');
        var formId = form.attr('id');

        event.stopPropagation();
        event.preventDefault();

        var validations = {};

        try {
            validations = eval('validations' + formId);
        } catch (e) {
        }

        if (typeof(validations[formId]) == 'undefined') {
            form.unbind('submit', ValidationForm.validate );
            return form.submit();
        }

        var formFields = ValidationForm.prepareFormFields(form[0].elements, formId);
        var formValidations = validations[formId];

        var regexp = null;
        var errors = [];
        var auxValue = null;

        var i, n, func, check;
        var expression = 'noexpression';
        var checkedConfirmation = new Array();
        var jsonReturn = false;
        var jsonData = null;

        for (var item in formValidations) {
            check = formValidations[item]['Check'];
            if (typeof(check) == 'undefined') {
                continue;
            }

            if (typeof(formFields['NoValidate_' + item]) != 'undefined') {
                continue;
            }


            patterns:
                    for (i = 0,n = check.length; i < n; i++) {
                        if (typeof(check[i]) == 'undefined') {
                            break patterns;
                        }

                        if (typeof(check[i]['Pattern']['isFunc']) != 'undefined' && check[i]['Pattern']['isFunc']) {
                            func = check[i]['Pattern']['Exec'];
                            auxValue = (formFields[item].length > 1) ? formFields[item] : formFields[item].value;
                            expression = window[func].apply(this, [auxValue, form[0]]);

                        } else {
                            regexp = new RegExp(check[i]['Pattern']['Exec']);
                            expression = regexp.test(formFields[item].value);
                        }

                        if (expression !== 'noexpression') {
                            if (expression === false || typeof expression === 'undefined') {
                                errors.push({'Name': item, 'Message': check[i]['Message'][0]});
                                break patterns;

                            }

                            if (expression !== true && !isNaN(expression)) {
                                return expression;
                            }

                            if (expression !== true && expression.isJSON && typeof(expression.isJSON) === 'function' && expression.isJSON()) {
                                jsonReturn = true;
                                jsonData = expression.evalJSON();
                                currentCheck = check[i];

                                for (var i = 0; i < jsonData.length; i++) {
                                    errors.push({'Name': jsonData[i].Name, 'Message': currentCheck['Message'][jsonData[i].Message]});
                                }

                                break patterns;
                            }
                        }

                        // if there is a confirmation field for "$item", checks if it's equal
                        if (ValidationForm._hasConfirmationField(item, formFields) &&
                                (formFields[item].value != formFields['Confirm_' + item].value) &&
                                (typeof(checkedConfirmation[item]) == 'undefined')
                                ) {
                            errors.push({'Name': 'Confirm_' + item, 'Message': check[i]['ConfirmationMessage']});
                            checkedConfirmation[item] = true;
                        }
                    }
        }

        if (errors.length > 0) {
            Feedback.form({'form': formId, 'fields': errors});
            return false;
        }

        if (!jsonReturn) {
            SendFormDataByAjaxRunMethod(formId, 'ValidationForm', 'validate', {'callback': ValidationForm.ajaxValidateResult, 'extra_data': form[0]});
        }

        return true;
    },

    'ajaxValidateResult': function (result, form) {
        Feedback.formClear(form.id);

        if (result == true) {
            ValidationForm.formFields = {};
            return form.submit();
        }

        if (result.isJSON()) {
            result = result.evalJSON();
            Feedback.form(result);
            return;
        }
    }
}